import React, { Component } from 'react';
import styled from 'styled-components'
import Layout from '../components/layout';
import SEO from '../components/seo';
import { colors } from '../style/colors';
import { navWidth } from '../components/reusables';

//NPM
import { FaRegFilePdf, FaSearch } from 'react-icons/fa'
import Fuse from 'fuse.js';


const Container = styled.div`
 width: calc(100vw - ${navWidth});
 margin-top: 170px;
 max-width: 1000px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
padding: 0 50px;

@media (max-width: 768px) {
    width: 100%;
    justify-content: flex-start;
}

@media (max-width: 550px) {
    margin-top: 90px;
}

`;
const Title = styled.h1`
  text-align: left;
  color: ${colors.main};
	font-family: 'expo-serif-pro', serif;
    line-height: 130%;
  margin-bottom: 3rem;
`;
const Grid = styled.div`
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 20px;
    width: 100%;

    @media (max-width: 768px) {
    grid-template-columns: 100%;

}
`
const ReportsContainer = styled.div`
@media (max-width: 768px) {
    order: 2;
}
`
const EmptyResults = styled.p`
  font-family: "expo-sans-pro";
  color: #bbb;
  font-size: 22px;
`;
const Report = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-right: 30px;
    margin-bottom: 30px;
`
const Name = styled.h3`
  margin: 0;
  font-family: "expo-sans-pro", sans-serif;
  font-weight: 400;
  
`;
const Search = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  @media (max-width: 768px) {
    order: 1;
    margin-bottom: 30px;
}

`;
const Input = styled.input`
  border: none;
  border-bottom: 1px solid #CCCCCC;
  color: black;
  padding: 10px;
  margin: 0 3px 0 0;
  width: 90%;
  font-family: "expo-sans-pro", sans-serif;
`;

class ReportsPage extends Component {
    state = {
        searchVal: "",
        searching: false,
        results: []
    }


    updateInput = e => {
        this.setState({ [e.target.name]: e.target.value, searching: true })
        let val = e.target.value

        if (val === "") {
            this.setState({ searching: false })
            return
        }

        var options = {
            keys: ['title', 'link'],
            id: 'title',
            threshold: 0.1
        }

        var fuse = new Fuse(reports, options)
        let results = fuse.search(val)

        this.setState({ results })

        console.log(results)


    }

    render() {
        const { searchVal, searching, results } = this.state
        return (
            <Layout>
                <SEO title="Reports" />
                <Container>
                    <Title>Keep up with our latest developments, and get reports about past years here.</Title>
                    <Grid>
                        {searching ?
                            <ReportsContainer>
                                <>
                                    {results.length === 0 ? <EmptyResults>No results found. Please refine your search and try again.</EmptyResults> :
                                        <>

                                            {results.map((report, index) => (
                                                <Report key={index}>
                                                    <Name>{report}</Name>
                                                    <FaRegFilePdf size={35} color="#F26247" />
                                                </Report>
                                            ))}
                                        </>
                                    }
                                </>
                            </ReportsContainer> :
                            <ReportsContainer>
                                {reports.map((report, index) => (
                                    <Report key={index}>
                                        <Name>{report.title}</Name>
                                        <a rel="noopener noreferrer" target="_blank" href="https://nz.expensereduction.com/wp-content/uploads/2018/02/Placeholder-PDF.pdf"><FaRegFilePdf size={35} color="#F26247" /></a>
                                    </Report>
                                ))}
                            </ReportsContainer>
                        }
                        <Search>
                            <Input value={searchVal} name="searchVal" onChange={this.updateInput} type="text" placeholder="Enter Search here" />
                            <FaSearch color="#CCCCCC" size={25} />
                        </Search>
                    </Grid>
                </Container>
            </Layout>
        );
    }
}

export default ReportsPage;

const reports = [
    {
        title: "2019 Annual Report",
        link: ""
    },
    {
        title: "2018 Annual Report",
        link: ""
    },
    {
        title: "2017 Annual Report",
        link: ""
    },
    {
        title: "2016 Annual Report",
        link: ""
    },
    {
        title: "2015 Annual Report",
        link: ""
    },
    {
        title: "1942 Annual Report",
        link: ""
    },
    {
        title: "1999 Company Roster",
        link: ""
    },
    {
        title: "2015 Company Roster",
        link: ""
    },
    {
        title: "1979 Company Transfers",
        link: ""
    },
]